import { useGetBulkDialogContent } from "@components/common/faro-table/bulk-dialog/bulk-dialog-helper";
import { BulkDialogs } from "@components/common/faro-table/bulk-dialog/bulk-dialog-types";
import {
  bulkActionResultsSelector,
  numberOfUpdatingItemsSelector,
} from "@store/table/table-selector";
import { useAppSelector } from "@store/store-helper";
import { nounPluralize } from "@utils/data-display";

/** Determines the content of bulk dialog and bulk success dialog for deleting snapshots */
export function useDeleteSnapshotsBulkDialogContent(): BulkDialogs {
  const numberOfUpdatingItems = useAppSelector(numberOfUpdatingItemsSelector);
  const { numberOfSuccess, numberOfErrors } = useAppSelector(
    bulkActionResultsSelector
  );

  const bulkDialogContent = useGetBulkDialogContent({
    initial: {
      title: "Delete these snapshots from workspace?",
      description:
        "When you confirm this action, all the data of these snapshots will be lost and cannot be recovered",
    },

    failed: {
      title: `Couldn't delete ${numberOfErrors} of ${numberOfUpdatingItems} snapshots`,
      description:
        "These snapshots couldn't be deleted from workspace, check the details and try again.",
    },
    confirmButtonText: "delete",
    entityType: "snapshot",
  });

  const successDialogContent = {
    title: `${nounPluralize({
      counter: numberOfSuccess,
      word: "snapshot",
    })} deleted`,
    description: "All selected snapshots have been permanently deleted",
  };

  return { bulkDialogContent, successDialogContent };
}
